import type { QuestionAnswer, Round, VoiceAnswerStatus } from "../types";
import { request } from "./client";

export function getRound(id: string): Promise<Round> {
	return request(`/api/rounds/${id}`);
}

export function updateTranscription(id: string, text: string): Promise<Round> {
	return request(`/api/rounds/${id}/transcription`, {
		method: "PATCH",
		body: JSON.stringify({ text }),
	});
}

export function approveTranscription(
	id: string,
): Promise<{ round_id: string; status: string }> {
	return request(`/api/rounds/${id}/process`, { method: "POST" });
}

export function submitAnswers(
	id: string,
	answers: QuestionAnswer[],
): Promise<{ round_id: string; status: string }> {
	return request(`/api/rounds/${id}/answers`, {
		method: "POST",
		body: JSON.stringify({ answers }),
	});
}

export function uploadVoiceAnswer(
	roundId: string,
	questionId: string,
	blob: Blob,
): Promise<VoiceAnswerStatus> {
	const form = new FormData();
	form.append("question_id", questionId);
	form.append("audio", blob, `${questionId}.webm`);
	return request(`/api/rounds/${roundId}/answers/voice`, {
		method: "POST",
		body: form,
	});
}

export function getVoiceAnswers(roundId: string): Promise<VoiceAnswerStatus[]> {
	return request(`/api/rounds/${roundId}/answers/voice`);
}

export function submitVoiceAnswers(
	roundId: string,
): Promise<{ round_id: string; status: string }> {
	return request(`/api/rounds/${roundId}/answers/voice/submit`, {
		method: "POST",
	});
}
